import React from 'react';
import PropTypes from 'prop-types';

// PrimeReact UI components
import {Checkbox} from 'primereact/checkbox';
import {MpaaRatingList} from '../catalog/catalog-constants';

// Styles
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const mpaaRatingList = ({existingRatings, criteriaId, onChange}) => {
    const options = [];

    for (let idx = 0; idx < MpaaRatingList.length; idx++) {
        let checked = false;

        if (existingRatings) {
            const enumValue = MpaaRatingList[idx].value;

            for (let r = 0; r < existingRatings.length; r++) {
                const ratingsValue = existingRatings[r];
                if (enumValue == ratingsValue) {
                    checked = true;
                    break;
                }
            }
        }

        options.push(
            <div className="p-col-12">
                <label className="p-checkbox-label" htmlFor={`mpaaRatingEntry${criteriaId}_${idx}`}>
                    {MpaaRatingList[idx].label}
                </label>
                <Checkbox
                    checked={checked}
                    id={`mpaaRatingEntry${criteriaId}_${idx}`}
                    inputId={`mpaaRatingEntry${criteriaId}`}
                    onChange={onChange}
                />
            </div>
        );
    }

    return <div>{options}</div>;
};

mpaaRatingList.propTypes = {
    criteriaId: PropTypes.number.isRequired,
    existingRatings: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default mpaaRatingList;
